import { ref, onMounted } from "vue";

export function useAsyncLoading(fn: Promise<any>) {
  const loading = ref(true);
  const data = ref(null);

  onMounted(async () => {
    loading.value = true;
    data.value = await fn;
    loading.value = false;
  });

  return [loading, data];
}
